import { LEGACY_TEAM_ACCESS } from 'domains/legacy-feature/access'

export const LEGACY_OPERATION_RESOURCES = {
  transits: {
    title        : 'Transit',
    singular     : 'Transit',
    allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
    create       : true,
    edit         : true,
    options      : true,
    stateFilter  : true,
    defaultState : 'received',
    states       : [ 'received', 'confirmed', 'rejected' ],
    columns      : [
      { key: 'product_name', label: 'Product' },
      { key: 'sku', label: 'SKU' },
      { key: 'arrival_time', label: 'Arrival Time', type: 'datetime' },
      { key: 'received_by', label: 'Received By' },
      { key: 'consignment_item', label: 'Consignment Item', type: 'boolean' },
      { key: 'notes', label: 'Notes' },
      { key: 'state', label: 'State', type: 'state' }
    ],
    fields: [
      { key: 'product_id', label: 'Product', type: 'select', optionsKey: 'products', createOnly: true, required: true },
      { key: 'purchase_order', label: 'Purchase Order', type: 'text' },
      { key: 'delivery_note', label: 'Delivery Note', type: 'text' },
      { key: 'arrival_time', label: 'Arrival Time', type: 'datetime-local', required: true },
      { key: 'received_by', label: 'Received By', type: 'text', required: true },
      { key: 'notes', label: 'Notes', type: 'textarea' }
    ]
  },
  outbounds: {
    title        : 'Outbound',
    singular     : 'Outbound',
    allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
    columns      : [
      { key: 'product_name', label: 'Product' },
      { key: 'sku', label: 'SKU' },
      { key: 'originator_type', label: 'Originator Type' },
      { key: 'reference_number', label: 'Reference Number' },
      { key: 'created_at', label: 'Created At', type: 'datetime' }
    ]
  },
  tanda_keluars: {
    title         : 'Tanda Keluar',
    singular      : 'Tanda Keluar',
    allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
    create        : true,
    options       : true,
    specificDate  : true,
    downloadPdf   : true,
    columns       : [
      { key: 'reference_number', label: 'Reference Number' },
      { key: 'consignor', label: 'Consignor' },
      { key: 'store_name', label: 'Store' },
      { key: 'created_at', label: 'Created At', type: 'datetime' }
    ],
    fields: [
      { key: 'user_id', label: 'User', type: 'select', optionsKey: 'users', allowBlank: true },
      {
        key        : 'product_ids',
        label      : 'Products',
        type       : 'multi-select',
        optionGroups: [
          { key: 'inventory_products', label: 'Inventory' },
          { key: 'rejected_transit_products', label: 'Transit (Rejected)' }
        ],
        required: true
      },
      { key: 'store_id', label: 'Store', type: 'select', optionsKey: 'stores', required: true }
    ]
  },
  carts: {
    title        : 'Carts',
    singular     : 'Cart',
    allowedRoles : LEGACY_TEAM_ACCESS.Sales.allowedRoles,
    edit         : true,
    options      : true,
    columns      : [
      { key: 'id', label: 'ID' },
      { key: 'user_name', label: 'User' },
      { key: 'user_email', label: 'Email' },
      { key: 'total_items', label: 'Total Items' },
      { key: 'subtotal', label: 'Subtotal', type: 'currency' }
    ],
    fields: [
      { key: 'product_ids', label: 'Products', type: 'multi-select', optionsKey: 'products' },
      { key: 'confirmation_string', label: 'Confirmation String', type: 'text' },
      { key: 'confirmation_expired_at', label: 'Confirmation Expired At', type: 'datetime-local' }
    ]
  },
  pickups: {
    title        : 'Pickup',
    singular     : 'Pickup',
    allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
    stateFilter  : true,
    states       : [ 'requested', 'confirmed', 'rejected', 'cancelled' ],
    columns      : [
      { key: 'user_name', label: 'User' },
      { key: 'reference_number', label: 'Reference Number' },
      { key: 'state', label: 'State', type: 'state' },
      { key: 'pickup_time', label: 'Pickup Time', type: 'datetime' },
      { key: 'complete_address', label: 'Complete Address' },
      { key: 'city_name', label: 'City' },
      { key: 'instruction', label: 'Instruction' }
    ]
  },
  pickup_products: {
    title        : 'Pickup Products',
    singular     : 'Pickup Product',
    allowedRoles : LEGACY_TEAM_ACCESS.Operations.allowedRoles,
    stateFilter  : true,
    states       : [ 'waiting_for_pickup', 'received', 'rejected' ],
    columns      : [
      { key: 'user_name', label: 'User' },
      { key: 'reference_number', label: 'Reference Number' },
      { key: 'product_name', label: 'Product' },
      { key: 'sku', label: 'SKU' },
      { key: 'state', label: 'State', type: 'state' }
    ]
  }
}
